import JassEnum from './enum';

/**
 * type race
 */
export default class JassRace extends JassEnum {}
